import { useAtom } from 'jotai';

import { Stack } from '@crossnokaye/ux-common';

import {
  SidebarAccordionItem,
  SidebarAccordionTemplate,
} from '@/components/templates/sidebar-accordion-template';
import { DeviceAttributeCheckboxList } from '@/features/clickhouse-trends/components/selections-sidebar/components/device-attributes/device-attribute-list';
import { SelectionsDeviceGroup } from '@/features/clickhouse-trends/components/selections-sidebar/selections.types';
import SelectionsState from '@/features/clickhouse-trends/components/selections-sidebar/state/selections.state';

type SelectionsListGroupingProps = {
  item: SidebarAccordionItem<SelectionsDeviceGroup>;
};

export const SelectionsListGrouping = ({ item }: SelectionsListGroupingProps) => {
  const [expandedSectionIds, setExpandedSectionIds] = useAtom(SelectionsState.expandedSectionIds);

  return (
    <Stack className="pl-4 bg-[#191919]">
      <SidebarAccordionTemplate
        state={{
          items: item.data.devices,
          expanded: expandedSectionIds,
          setExpanded: setExpandedSectionIds,
        }}
        variant="small"
        keyGenerator={(item) => item.value}
        contentComponent={DeviceAttributeCheckboxList}
      />
    </Stack>
  );
};
